export default __webpack_public_path__ + "static/media/0021.32bc2358.jpg";